import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "./app/app.module";
import {ENVIRONMENT} from "./environments/environment";

if (ENVIRONMENT.env === 'production') {
	enableProdMode();
} // end if

const init = () =>
{

    platformBrowserDynamic().bootstrapModule(AppModule)
		.then(() => (<any>window).appBootstrap && (<any>window).appBootstrap())
		.catch(OBJ_error => console.error("Bootstrap Error =>", OBJ_error));

};

// init on first load
init();
